import { useState, type ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageHeader, SideNav, Stack, t } from '@kanbios/ui';
import { Shell } from '../components/Shell';
import { AccessSection } from './settings/AccessSection';
import { IntegrationsSection } from './settings/IntegrationsSection';
import { ThresholdsSection } from './settings/ThresholdsSection';

const SECTIONS = [
  { id: 'thresholds', icon: 'tune' },
  { id: 'integrations', icon: 'hub' },
  { id: 'access', icon: 'key' },
] as const;
type SectionId = (typeof SECTIONS)[number]['id'];

/**
 * Réglages (SPEC-013), built on the DSM LayoutSettings frame. Sections appear
 * with their modules; delivered so far: thresholds and colour code, integrations, server access.
 */
export function SettingsPage() {
  const [params, setParams] = useSearchParams();
  const tab: SectionId = SECTIONS.some(s => s.id === params.get('tab')) ? (params.get('tab') as SectionId) : 'integrations';
  // A section with changes puts its save bar in the AppShell footer (LayoutSettings).
  const [footer, setFooter] = useState<ReactNode>(null);

  return (
    <Shell crumbs={[{ label: t('nav.settings') }, { label: t(`settings.tabs.${tab}`) }]} footer={footer}>
      <Stack gap={24}>
        <PageHeader title={t('settings.title')} subtitle={t('settings.subtitle')} />
        <div className="kui-settings">
          <SideNav
            label={t('settings.nav.label')}
            value={tab}
            onChange={id => setParams({ tab: id })}
            groups={[{ label: t('settings.nav.group'), items: SECTIONS.map(s => ({ id: s.id, label: t(`settings.nav.${s.id}`), icon: s.icon })) }]}
          />
          <div className="kui-settings__main">
            {tab === 'thresholds' ? <ThresholdsSection onFooter={setFooter} /> : tab === 'integrations' ? <IntegrationsSection /> : <AccessSection />}
          </div>
        </div>
      </Stack>
    </Shell>
  );
}
